import { zipObject } from 'es-toolkit';

import seedTypeFilter from '../filters/seedType';

export default class SeedType {

    static SEED = 'SEED';
    static HALF_GROWN = 'HALF_GROWN';
    static CONSUMPTION = 'CONSUMPTION';

    static options(): Record<string, string> {

        const keys = Object.keys(SeedType);

        return zipObject(keys, keys.map(key => seedTypeFilter(key)));
    }
}
